<template>
  <div class="waterfall-container">
    <!-- 顶部控制栏 -->
    <!-- <div class="control-bar">
      <h1 class="title">Vue瀑布流图片画廊</h1>
      <div class="controls">
        <label class="control-label">
          列数：
          <select v-model="columnCount" @change="updateLayout" class="select-input">
            <option value="2">2列</option>
            <option value="3">3列</option>
            <option value="4">4列</option>
            <option value="5">5列</option>
            <option value="6">6列</option>
          </select>
        </label>
        <label class="control-label">
          间距：
          <input 
            type="range" 
            v-model="columnGap" 
            min="10" 
            max="30" 
            @input="updateLayout"
            class="slider-input"
          >
          <span>{{ columnGap }}px</span>
        </label>
        <button @click="shuffleItems" class="shuffle-btn">
          <i class="fas fa-random"></i> 随机排序
        </button>
      </div>
    </div> -->

    <!-- 瀑布流主体 -->
    <div 
      class="waterfall-grid" 
      :style="{
        'column-count': columnCount,
        'column-gap': columnGap + 'px'
      }"
    >
      <div 
        v-for="(item, index) in displayedItems" 
        :key="item.id"
        class="waterfall-item"
        @click="handleItemClick(item,index)"
      >
        <div class="image-container">
          <img 
            :src="item.image" 
            :alt="item.alt"
            loading="lazy"
            class="waterfall-image"
          >
          <!-- <div class="image-overlay">
            <span class="view-details">查看详情</span>
          </div> -->
        </div>
        <div class="item-content">
          <h3 class="item-title">{{ item.title }}</h3>
          <p class="item-description">{{ item.description }}</p>
          <div class="item-meta">
            <span class="meta-item">
              <i class="fas fa-heart"></i> {{ item.likes }}
            </span>
            <span class="meta-item">
              <i class="fas fa-eye"></i> {{ item.views }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 加载更多 -->
    <div class="load-more-section" v-if="hasMoreItems">
      <button @click="loadMore" class="load-more-btn" :disabled="loading">
        <span v-if="loading">加载中...</span>
        <span v-else>加载更多图片</span>
      </button>
    </div>

    <!-- 图片详情模态框 -->
    <div v-if="selectedItem" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="closeModal">
          <i class="fas fa-times"></i>
        </button>
        <img :src="selectedItem.image" :alt="selectedItem.alt" class="modal-image">
        <div class="modal-info">
          <h2>{{ selectedItem.title }}</h2>
          <p>{{ selectedItem.description }}</p>
          <div class="modal-meta">
            <div class="meta-stat">
              <i class="fas fa-heart"></i>
              <span>{{ selectedItem.likes }} 喜欢</span>
            </div>
            <div class="meta-stat">
              <i class="fas fa-eye"></i>
              <span>{{ selectedItem.views }} 浏览</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue'
import p1 from '@/assets/image/home/1.webp';
import p2 from '@/assets/image/home/2.webp';
import p3 from '@/assets/image/home/3.webp';
import p4 from '@/assets/image/home/cut1.webp';
import p5 from '@/assets/image/home/5.webp';
import p6 from '@/assets/image/home/6.webp';
import p7 from '@/assets/image/home/cut7.webp';
import p8 from '@/assets/image/home/8.webp';
import p9 from '@/assets/image/home/9.webp';
import p10 from '@/assets/image/home/10.webp';
import p11 from '@/assets/image/home/cut9.webp';
import p12 from '@/assets/image/home/12.webp';
import p13 from '@/assets/image/home/13.webp';
import p14 from '@/assets/image/home/cut11.webp';
import p15 from '@/assets/image/home/15.webp';
import p16 from '@/assets/image/home/16.webp';
import p17 from '@/assets/image/home/17.webp';
import p18 from '@/assets/image/home/cut10.webp';
import p19 from '@/assets/image/home/19.webp';
import p20 from '@/assets/image/home/20.webp';
import p21 from '@/assets/image/home/cut12.webp';
import p22 from '@/assets/image/home/22.webp';
import p23 from '@/assets/image/home/23.webp';
import p24 from '@/assets/image/home/24.webp';
import p25 from '@/assets/image/home/cut8.webp';
import p26 from '@/assets/image/home/25.webp';
import p27 from '@/assets/image/home/3.webp';
import p28 from '@/assets/image/home/cut1.webp';
export default {
  name: 'waterfallGallery',
  setup() {
    // 响应式数据
    const columnCount = ref(8)
    const columnGap = ref(6)
    const selectedItem = ref(null)
    const loading = ref(false)
    const itemsPerLoad = ref(7)
    const loadedCount = ref(100)

    // 模拟图片数据
    const allItems = ref([
        { image: p1, alt: 'Image 1' },
        { image: p2, alt: 'Image 2' },
        { image: p3, alt: 'Image 3' },
        { image: p4, alt: 'Image 4' },
        { image: p5, alt: 'Image 5' },
        { image: p6, alt: 'Image 5' },
        { image: p7, alt: 'Image 5' },
        { image: p8, alt: 'Image 5' },
        { image: p9, alt: 'Image 5' },
        { image: p10, alt: 'Image 5' },
        { image: p11, alt: 'Image 5' },
        { image: p12, alt: 'Image 5' },
        { image: p13, alt: 'Image 5' },
        { image: p14, alt: 'Image 5' },
        { image: p15, alt: 'Image 5' },
        { image: p16, alt: 'Image 5' },
        { image: p17, alt: 'Image 5' },
        { image: p18, alt: 'Image 5' },
        { image: p19, alt: 'Image 5' },
        { image: p20, alt: 'Image 5' },
        { image: p21, alt: 'Image 5' },
        { image: p22, alt: 'Image 5' },
        { image: p23, alt: 'Image 5' },
        { image: p24, alt: 'Image 5' },
        { image: p25, alt: 'Image 5' },
        { image: p26, alt: 'Image 5' },
        { image: p27, alt: 'Image 5' },
        { image: p28, alt: 'Image 5' },
    ])

    // 计算属性
    const displayedItems = computed(() => 
      allItems.value.slice(0, loadedCount.value)
    )

    const hasMoreItems = computed(() => 
      loadedCount.value < allItems.value.length
    )

    // 方法
    const updateLayout = () => {
      console.log('布局已更新:', { columns: columnCount.value, gap: columnGap.value })
    }

    const shuffleItems = () => {
      loading.value = true
      setTimeout(() => {
        allItems.value = [...allItems.value].sort(() => Math.random() - 0.5)
      loading.value = false
    }, 500)
    }

    const loadMore = () => {
      loading.value = true
      setTimeout(() => {
        loadedCount.value += itemsPerLoad.value
        loading.value = false
      }, 800)
    }

    const handleItemClick = (item) => {
      selectedItem.value = item
    }

    const closeModal = () => {
      selectedItem.value = null
    }

    // 生命周期
    onMounted(() => {
      console.log('瀑布流组件已挂载')
    })

    return {
      columnCount,
      columnGap,
      selectedItem,
      loading,
      displayedItems,
      hasMoreItems,
      updateLayout,
      shuffleItems,
      loadMore,
      handleItemClick,
      closeModal
    }
  }
}
</script>

<style scoped>
.waterfall-container {
  /* max-width: 1500px; */
  width: 100%;
  margin: 0 auto;
  padding: 2px 1px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* 控制栏样式 */
.control-bar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 16px;
  padding: 2px;
  margin-bottom: 2px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.15);
  color: white;
}

.title {
  font-size: 2.5px;
  margin-bottom: 1.5px;
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0,0,0,0.3);
}

.controls {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2px;
  flex-wrap: wrap;
}

.control-label {
  display: flex;
  align-items: center;
  gap: 0.5px;
  font-weight: 500;
}

.select-input, .slider-input {
  padding: 0.5px;
  border: none;
  border-radius: 8px;
  background: rgba(255,255,255,0.9);
  color: #333;
}

.shuffle-btn, .load-more-btn {
  background: rgba(255,255,255,0.9);
  color: #333;
  border: none;
  padding: 0.75px 1.5px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.shuffle-btn:hover, .load-more-btn:hover:not(:disabled) {
  background: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.load-more-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 瀑布流核心样式 */
.waterfall-grid {
  column-count: v-bind(columnCount);
  column-gap: v-bind(columnGap + 'px');
  padding: 1px;
  /* display: flex; */
  /* justify-content: center; */
}

.waterfall-item {
  break-inside: avoid;
  margin-bottom: 5px;
  /* background: white; */
  /* border-radius: 12px; */
  box-shadow: 0 5px 20px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  overflow: hidden;
  cursor: pointer;
}

.waterfall-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0,0,0,0.15);
}

.image-container {
  position: relative;
  overflow: hidden;
}

.waterfall-image {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

.waterfall-item:hover .waterfall-image {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, transparent 50%, rgba(0,0,0,0.7));
  opacity: 0;
  transition: opacity 0.3s ease;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 2px;
}

.waterfall-item:hover .image-overlay {
  opacity: 1;
}

.view-details {
  color: white;
  font-weight: 500;
  padding: 0.5px 1px;
  background: rgba(102,126,234,0.8);
  border-radius: 20px;
  font-size: 0.9px;
}

/* 内容区域样式 */
.item-content {
  padding: 1.5px;
}

.item-title {
  font-size: 1.3px;
  margin-bottom: 0.75px;
  color: #333;
  line-height: 1.3;
}

.item-description {
  color: #666;
  font-size: 0.95px;
  line-height: 1.5;
  margin-bottom: 1px;
}

.item-meta {
  display: flex;
  gap: 1px;
}

.meta-item {
  color: #888;
  font-size: 0.85px;
  display: flex;
  align-items: center;
  gap: 0.25px;
}

/* 模态框样式 */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 25px 50px rgba(0,0,0,0.3);
}

.close-btn {
  position: absolute;
  top: 1px;
  right: 1px;
  background: rgba(0,0,0,0.5);
  color: white;
  border: none;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1001;
  transition: background 0.3s ease;
}

.close-btn:hover {
  background: rgba(0,0,0,0.7);
}

.modal-image {
  width: 100%;
  height: auto;
  display: block;
}

.modal-info {
  padding: 2px;
}

.modal-info h2 {
  font-size: 1.8px;
  margin-bottom: 1px;
  color: #333;
}

.modal-info p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5px;
}

.modal-meta {
  display: flex;
  gap: 1.5px;
}

.meta-stat {
  display: flex;
  align-items: center;
  gap: 0.5px;
  color: #888;
}

/* 加载更多区域 */
.load-more-section {
  text-align: center;
  margin-top: 2px;
  padding: 2px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .waterfall-grid {
    column-count: 2;
  }
  
  .controls {
    gap: 1px;
  }
  
  .title {
    font-size: 2px;
  }
}

@media (max-width: 480px) {
  .waterfall-grid {
    column-count: 1;
  }
  
  .control-bar {
    padding: 1.5px;
  }
  
  .waterfall-container {
    padding: 1px 0.5px;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.waterfall-item {
  animation: fadeInUp 0.6s ease;
}
</style>
